import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 1.978C6.12 1.978 5 3.085 5 4.451v7.912c0 .827.293 1.25.515 1.469a1.424 1.424 0 0 0 .422.285l-.007-.002-.006-.002-.004-.002h-.002c-.001 0-.002 0-.297.944a76.11 76.11 0 0 1-.296.945l-.003-.001-.006-.002-.013-.004a1.893 1.893 0 0 1-.128-.047 2.916 2.916 0 0 1-.28-.13 3.422 3.422 0 0 1-.79-.581C3.519 14.657 3 13.734 3 12.363V4.451C3 1.993 5.015 0 7.5 0S12 1.993 12 4.45v7.666c0 1.502-1.231 2.72-2.75 2.72s-2.75-1.218-2.75-2.72V3.462h2v8.654c0 .41.336.742.75.742s.75-.332.75-.742V4.451c0-1.366-1.12-2.473-2.5-2.473Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgPaperClip = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgPaperClip;
